import { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  title: string;
}

export function Page({ children }: Props) {
  return children;
}
